// extracted by mini-css-extract-plugin
export var active = "FaqSectionList-module--active--7e2de";
export var btn = "FaqSectionList-module--btn--be167";
export var collapsibleSidebar = "FaqSectionList-module--collapsibleSidebar--e47d2";
export var collapsibleSidebarBody = "FaqSectionList-module--collapsibleSidebarBody--a6b11";
export var open = "FaqSectionList-module--open--36a3e";
export var sectionItem = "FaqSectionList-module--sectionItem--6e2e8";
export var sectionList = "FaqSectionList-module--sectionList--d4394";
export var sidebar = "FaqSectionList-module--sidebar--a2710";
export var sidebarWrapper = "FaqSectionList-module--sidebarWrapper--0c0e5";
export var svg = "FaqSectionList-module--svg--e5984";